var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 258.887,
    height: 45.473,
    viewBox: "0 0 258.887 45.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1486",
    "data-name": "Rectangle 1486",
    width: 258.887,
    height: 45.473,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrk-15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3509",
    "data-name": "Group 3509",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11168",
    "data-name": "Path 11168",
    d: "M20.728,11.369A16.051,16.051,0,0,1,25.6,9.256a17.171,17.171,0,0,1,18.947,7.97c3.316,5.521,3.611,11.223.256,16.829a16.761,16.761,0,0,1-12.272,8.019,17.942,17.942,0,0,1-10.779-1.612c-.314-.148-.613-.323-.965-.51,4.841-3.577,7.642-8.212,7.517-14.28-.124-5.97-2.951-10.606-7.573-14.3",
    transform: "translate(7.443 3.136)",
    fill: "#63144d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11169",
    "data-name": "Path 11169",
    d: "M34.641,23.671a17.107,17.107,0,0,0-7.308-11.729A16.183,16.183,0,0,0,15.378,8.881,17.072,17.072,0,0,0,2.372,17.715c-2.82,4.9-3.243,10.046-.629,15.146,3.254,6.35,8.789,9.132,15.29,9.481,5.181-.14,9.4-1.621,12.82-4.939a15.2,15.2,0,0,0,4.789-13.732",
    transform: "translate(0 3.132)",
    fill: "#63144d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11170",
    "data-name": "Path 11170",
    d: "M47.8,15.219c1.17,0,2.293-.018,3.414.02.16.005.363.25.462.429q3.137,5.684,6.253,11.378c.1.182.205.359.356.624.281-.5.519-.916.747-1.337q2.854-5.274,5.7-10.553a.89.89,0,0,1,.936-.576c.93.043,1.861.012,2.855.012.016.22.042.405.042.59,0,5.163,0,10.326.011,15.489,0,.469-.109.661-.61.633a19.687,19.687,0,0,0-2.157,0c-.48.026-.582-.154-.576-.6.038-3.474.052-6.948.072-10.423a1.234,1.234,0,0,0-.129-.65q-.159.289-.317.579c-1.91,3.535-3.827,7.064-5.714,10.612a.841.841,0,0,1-.932.477c-.438-.022-.824.046-1.11-.491-1.884-3.525-3.815-7.026-5.731-10.534-.11-.2-.228-.4-.417-.724V31.913c-.973,0-1.939.01-2.906-.012-.094,0-.212-.174-.268-.292a.878.878,0,0,1-.014-.345q0-7.714,0-15.43c0-.189.018-.376.03-.614",
    transform: "translate(17.15 5.459)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11171",
    "data-name": "Path 11171",
    d: "M178.181,15.217c1.094,0,2.139-.02,3.182.019.181.007.381.238.525.405q4.4,5.162,8.791,10.336c.258.3.519.606.887,1.036V15.26h3.341V31.916c-.753,0-1.524-.052-2.283.015a1.792,1.792,0,0,1-1.677-.757c-2.982-3.553-6-7.074-9.012-10.6-.1-.116-.205-.224-.405-.439-.016.31-.035.507-.035.7,0,3.474-.014,6.948.012,10.42,0,.548-.162.7-.689.674-.867-.041-1.737-.011-2.635-.011Z",
    transform: "translate(63.981 5.462)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11172",
    "data-name": "Path 11172",
    d: "M100,31.911c-1.04,0-2.064.029-3.085-.023-.212-.011-.439-.288-.608-.487q-4.085-4.781-8.157-9.575c-.459-.54-.923-1.072-1.487-1.727-.018.366-.034.568-.034.772,0,3.453-.011,6.907.008,10.362,0,.511-.1.735-.667.7-.735-.052-1.476-.026-2.214-.008-.349.008-.477-.109-.476-.468q.012-7.887,0-15.776c0-.353.113-.477.469-.469.854.019,1.711-.019,2.563.023a1.057,1.057,0,0,1,.665.355q4.467,5.221,8.907,10.466l.829.97V15.258H100Z",
    transform: "translate(29.904 5.461)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11173",
    "data-name": "Path 11173",
    d: "M112.693,26.6h-3.568V23.821H115.9c.012.163.042.329.042.5,0,2.058,0,4.114.007,6.172a.62.62,0,0,1-.439.7,17.428,17.428,0,0,1-9.842.949,8.577,8.577,0,0,1,.665-16.961,15.8,15.8,0,0,1,8.016.905.7.7,0,0,1,.537.757c0,.887.079,1.775.132,2.756l-.72-.315a13.244,13.244,0,0,0-6.6-1.384c-3.694.355-5.765,3-5.249,6.679a5.663,5.663,0,0,0,4.87,4.871,11.012,11.012,0,0,0,4.9-.289.539.539,0,0,0,.47-.65c-.029-.6-.007-1.2-.007-1.911",
    transform: "translate(35.448 5.388)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11174",
    "data-name": "Path 11174",
    d: "M65.73,31.918c.689-1.367,1.314-2.612,1.943-3.854Q70.8,21.879,73.92,15.692a.748.748,0,0,1,.807-.484c.757.029,1.518-.015,2.274.023a.8.8,0,0,1,.579.328q4.189,8.028,8.341,16.077a1.384,1.384,0,0,1,.063.222,3.544,3.544,0,0,1-.443.058,16.171,16.171,0,0,0-2.039.02,1.563,1.563,0,0,1-1.953-1.2,8.535,8.535,0,0,0-.855-1.717.866.866,0,0,0-.6-.391q-4.489-.039-8.979,0a.844.844,0,0,0-.6.385c-.435.8-.829,1.625-1.2,2.457a.7.7,0,0,1-.764.462c-.89-.026-1.78-.008-2.809-.008m6.162-5.828h7.389L75.6,18.72l-3.712,7.37",
    transform: "translate(23.602 5.46)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11175",
    "data-name": "Path 11175",
    d: "M126.947,15.235h3.233c.012.207.037.412.038.616,0,3.222.007,6.445-.005,9.667a11.112,11.112,0,0,1-.129,1.74,5.52,5.52,0,0,1-4.856,4.871,13.188,13.188,0,0,1-5.385-.045,5.479,5.479,0,0,1-4.715-5.5c-.111-3.7-.046-7.414-.056-11.121a1.1,1.1,0,0,1,.052-.213H118.6v.693q0,4.571,0,9.143c.005,3.029,1.163,4.2,4.193,4.225a7.155,7.155,0,0,0,1.56-.151,2.944,2.944,0,0,0,2.535-3.036c.052-3.357.045-6.715.061-10.072,0-.25,0-.5,0-.82",
    transform: "translate(41.317 5.47)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11176",
    "data-name": "Path 11176",
    d: "M166.245,31.86V15.245h11.007v2.694h-7.479V21.69h6.54c0,.87.018,1.68-.024,2.486-.005.1-.325.275-.5.276-1.789.02-3.576.012-5.363.012h-.661v4.581h7.96V31.86Z",
    transform: "translate(59.695 5.474)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11177",
    "data-name": "Path 11177",
    d: "M157.928,21.715h6.518c0,.856.019,1.665-.023,2.469-.005.1-.33.265-.508.266-1.768.02-3.536.012-5.3.012h-.684v4.554H165.9c0,.923.016,1.787-.024,2.647,0,.088-.355.228-.545.228-2.546.016-5.09.011-7.635.011-.951,0-1.9-.01-2.855,0-.336.005-.488-.086-.488-.457q.014-7.945.01-15.892a2.192,2.192,0,0,1,.05-.317h10.991v2.694h-7.478Z",
    transform: "translate(55.426 5.473)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11178",
    "data-name": "Path 11178",
    d: "M129.556,27.862a10.217,10.217,0,0,0,4.187,1.689,8.29,8.29,0,0,0,3.641-.091,3.762,3.762,0,0,0,1.378-.705,1.646,1.646,0,0,0-.239-2.785,12.762,12.762,0,0,0-2.441-.9c-1.151-.349-2.338-.587-3.475-.968a4.081,4.081,0,0,1-3.119-4.077,4.333,4.333,0,0,1,3.076-4.393,13.139,13.139,0,0,1,7.073-.295c1.574.3,1.566.323,1.628,1.9.022.54.073,1.078.118,1.707-.25-.1-.438-.182-.624-.264a10.923,10.923,0,0,0-6.271-.757,3.2,3.2,0,0,0-1.033.368,1.466,1.466,0,0,0-.158,2.575,12.485,12.485,0,0,0,2.715,1.138c1.163.37,2.385.556,3.54.943a3.965,3.965,0,0,1,3.112,3.89,4.67,4.67,0,0,1-2.771,4.818,8.2,8.2,0,0,1-2.168.633,15.3,15.3,0,0,1-7.407-.722.682.682,0,0,1-.526-.708c-.05-.966-.149-1.929-.238-3",
    transform: "translate(46.496 5.385)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11179",
    "data-name": "Path 11179",
    d: "M146.478,18.151h-5.386v-2.9h14.17v2.883H150V31.86h-3.517Z",
    transform: "translate(50.663 5.475)",
    fill: "#191717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11180",
    "data-name": "Path 11180",
    d: "M33.578,23.545a16.274,16.274,0,0,0-6.952-11.157A15.393,15.393,0,0,0,15.253,9.476a16.242,16.242,0,0,0-12.373,8.4C.2,22.537-.205,27.438,2.281,32.288c3.1,6.04,8.361,8.687,14.545,9.019,4.929-.133,8.94-1.544,12.2-4.7a14.457,14.457,0,0,0,4.556-13.062",
    transform: "translate(0.224 3.348)",
    fill: "#b21f36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11181",
    "data-name": "Path 11181",
    d: "M14.105,22.923a26.043,26.043,0,0,1-4.375-5.95,4.112,4.112,0,0,1,2.938-5.7,10,10,0,0,1,2.938.012,4.115,4.115,0,0,1,2.858,5.741,26.514,26.514,0,0,1-4.36,5.9",
    transform: "translate(3.355 4.011)",
    fill: "#fee0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11182",
    "data-name": "Path 11182",
    d: "M14.121,22.32c.705.817,1.418,1.534,2,2.346a27.05,27.05,0,0,1,2.293,3.558,3.884,3.884,0,0,1-1.6,5.219c-2.105,1.3-5.864,1.007-7.183-2.07a3.347,3.347,0,0,1-.076-2.6,16.848,16.848,0,0,1,3.031-4.728c.468-.565.973-1.1,1.532-1.725",
    transform: "translate(3.351 8.015)",
    fill: "#fee0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11183",
    "data-name": "Path 11183",
    d: "M14.662,22c-.012-.049-.026-.071-.02-.083a19.039,19.039,0,0,1,4.715-6.276,3.357,3.357,0,0,1,5.428,1.377,5.936,5.936,0,0,1,.652,2.8,2.655,2.655,0,0,1-2.692,2.728c-2.635-.061-5.265-.3-7.9-.469a.612.612,0,0,1-.186-.08",
    transform: "translate(5.257 5.303)",
    fill: "#fee0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11184",
    "data-name": "Path 11184",
    d: "M14.028,22.184c-.283.491-.5.878-.726,1.253A21.321,21.321,0,0,1,9.551,28.3a3.824,3.824,0,0,1-3.2,1.048,2.809,2.809,0,0,1-1.964-1.127,6.153,6.153,0,0,1-1.271-3.559,2.768,2.768,0,0,1,3-3.027c2.189.052,4.376.234,6.564.37.4.026.8.1,1.348.175",
    transform: "translate(1.117 7.77)",
    fill: "#fee0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11185",
    "data-name": "Path 11185",
    d: "M13.9,22.081c-1.229.124-2.456.277-3.687.363s-2.482.13-3.723.147c-2.541.037-3.835-1.564-3.245-4.05a8.285,8.285,0,0,1,.781-1.994,3.17,3.17,0,0,1,4.637-1.226,12.577,12.577,0,0,1,2.654,2.569c.993,1.253,1.812,2.645,2.706,3.978l-.124.213",
    transform: "translate(1.115 5.3)",
    fill: "#fee0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11186",
    "data-name": "Path 11186",
    d: "M14.585,22.174c.892-.106,1.71-.239,2.535-.292,1.722-.109,3.448-.222,5.173-.247a2.868,2.868,0,0,1,3.1,3.622,8.348,8.348,0,0,1-.927,2.547,3.224,3.224,0,0,1-4.549,1.123,8.735,8.735,0,0,1-2.139-1.938c-1.053-1.359-1.963-2.831-2.926-4.259a5.137,5.137,0,0,1-.269-.555",
    transform: "translate(5.237 7.768)",
    fill: "#fee0d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11187",
    "data-name": "Path 11187",
    d: "M29.92,3.786a28.446,28.446,0,0,1-.564,5.544.612.612,0,0,1-.776.576c-.428-.068-.389-.381-.344-.718a10.376,10.376,0,0,0-1.774-7.183C25.8.991,26.172.2,27.417.023a3.046,3.046,0,0,1,2.033.56c.3.179.317.516.356.825.043.345.1.693.11,1.04.018.446,0,.893,0,1.339",
    transform: "translate(9.386 0)",
    fill: "#7aa82d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk15);
export default __webpack_public_path__ + "static/media/wrk-15.598b72fc47db5004f687703403431886.svg";
export { ForwardRef as ReactComponent };